
  import api from "@/api/index"; //ABP API接口
  import {Component, Ref} from "vue-property-decorator";
  import {ElementTableView} from "@/lib/ElementTableView";
  import RejectDialog from "@/components/RejectDialog/index.vue";

  import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
  import {
    ActivityDto,
    AuditUserLogStatus,
    AuditUserLogType,
    PayOrderType,
    PayrollRequisitionDto,
    ProjectDto,
    RefundLogDto,
    ReimbursementDto
  } from "@/api/appService";
  import AuditTabOfReimbursement from "@/views/audits/tabs/tabReimbursement.vue";
  import AuditTabOfProject from "@/views/audits/tabs/tabProject.vue";
  import AuditTabOfActivity from "@/views/audits/tabs/tabActivity.vue";
  import AuditTabOfPayrollRequisition from "@/views/audits/tabs/tabPayrollRequisition.vue";
  import AuditTabOfRefund from "@/views/audits/tabs/tabRefund.vue";
  import AuditCount from "@/views/audits/components/AuditCount.vue";

  @Component({
  name: "MyAudit",
  components: {
    AuditCount,
    AuditTabOfRefund,
    AuditTabOfPayrollRequisition,
    AuditTabOfActivity, AuditTabOfProject, AuditTabOfReimbursement, RejectDialog, AgileAuditTag }
})
export default class MyAudit extends ElementTableView {
  activeName:string = 'project';

  countDic:any = {
    project:0,
    activity:0,
    refund:0,
    reimbursement:0,
    payrollRequisition:0
  }

  handleCountChange(target:string,$event:number){
    this.countDic[target] = $event;
  }

}
